export class SharedInspectionFinding {
  constructor(
    public readonly uuid: string,
    public readonly inspection_uuid: string,
    public readonly token: string | null,
    public readonly name: string,
    public readonly email: string,
    public readonly sent_at: Date | null,
    public readonly sent_mail_uuid: string,
    public readonly expires_at: Date | null,
    public readonly opened_at: Date | null,
    public readonly modified_at: Date | null,
    public readonly created_at: Date | null,
    public readonly updated_at: Date | null,
  ) {}

  static fromJson(json: any): SharedInspectionFinding {
    return new SharedInspectionFinding(
      json["uuid"],
      json["inspection_uuid"],
      json["token"],
      json["name"],
      json["email"],
      json["sent_at"] ? new Date(json["sent_at"]) : null,
      json["sent_mail_uuid"],
      json["expires_at"] ? new Date(json["expires_at"]) : null,
      json["opened_at"] ? new Date(json["opened_at"]) : null,
      json["modified_at"] ? new Date(json["modified_at"]) : null,
      json["created_at"] ? new Date(json["created_at"]) : null,
      json["updated_at"] ? new Date(json["updated_at"]) : null,
    );
  }
}
